export enum Pages {
  ORDERS = 'orders',
  HOME = 'home',
  CATALOG = 'catalog',
  VIDEOS = 'videos',
}
